import type { ReactNode } from 'react'
import { createContext, useContext, useMemo } from 'react'

type SidebarContextValue = {
  isCollapsed: boolean
  onToggle: () => void
  onExpand: () => void
}

const SidebarContext = createContext<SidebarContextValue | null>(null)

type SidebarProviderProps = {
  children: ReactNode
  isCollapsed: boolean
  onToggle: () => void
  onExpand: () => void
}

export function SidebarProvider({ children, isCollapsed, onToggle, onExpand }: Readonly<SidebarProviderProps>) {
  const value = useMemo(
    () => ({
      isCollapsed,
      onToggle,
      onExpand,
    }),
    [isCollapsed, onToggle, onExpand],
  )

  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
}

export function useSidebar() {
  const context = useContext(SidebarContext)
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider')
  }
  return context
}
